import { graphql } from "@/shared/gql";
import { useSuspenseQuery } from "@apollo/client";
import { useCompanyId } from "@/entities/company/hooks/use-company-id";
import { EntityNotFoundError } from "@/shared/lib/errors/404-not-found-error";
import { CurrentCompanyQueryVariables } from "@/shared/gql/graphql";
import { getPreloadQuery } from "@/shared/gql/apollo-client";

export const CurrentCompany = graphql(`
  query CurrentCompany($companyId: ID!) {
    currentUser(company: $companyId) {
      id
      ...AllCompanyUserProps
    }
  }
`);

export const preloadCurrentCompanyQuery = (
  vars: CurrentCompanyQueryVariables,
) => {
  getPreloadQuery()(CurrentCompany, {
    variables: vars,
  });
};

export const useFetchCurrentCompanyQuery = () => {
  const companyId = useCompanyId();
  const result = useSuspenseQuery(CurrentCompany, {
    variables: { companyId },
  });

  if (result.error) {
    throw result.error;
  }

  if (!result.data?.currentUser) {
    throw new EntityNotFoundError("User");
  }

  if (!result.data.currentUser.company) {
    throw new EntityNotFoundError("Company");
  }

  return result.data.currentUser.company;
};
